
import React      from 'react';
import CSSModules from 'react-css-modules';

import classnames from 'classnames/bind';

import style from './style.scss';

class AccordionContent extends React.Component {
    
    _getAccordionContentClass() {
        
        var cx = classnames.bind(style);
        
        return cx({
            'content--hidden': !this.props.expanded
        });
    }

    render() {

        return (
            <article className={ this._getAccordionContentClass() } { ...this.props }>

                { this.props.expanded ? this.props.children : null }

            </article>
        );
    }
}

export default CSSModules(AccordionContent, style);


// WEBPACK FOOTER //
// ./components/AccordionContent/index.js